import { useEffect, useState } from "react";
import {
    Directory,
    DirectoryQuery,
    fetchDirectories,
} from "../../common/redux/documentsAction";

export const useDirectories = (query: DirectoryQuery = {}) => {
    const [directories, setDirectories] = useState<Directory[]>([]);
    const [loading, setLoading] = useState(false);

    const getDirectories = async () => {
        setLoading(true);
        try {
            const data = await fetchDirectories(query);
            setDirectories(data);
        } catch (error) {
            console.error("Error fetching directories:", error);
            setDirectories([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDirectories();
    }, [query.type, query.name]);

    return { directories, loading, refresh: getDirectories };
};
